/**
 * Brand color tokens — "Up North Cottage" kit.
 * Mirrors the `BK` object from the source kit (foundations.jsx) so the ported
 * mark components can reference brand hexes directly. The CSS custom properties
 * in `src/assets/main.css` remain the source of truth for utility classes;
 * these constants are for inline SVG/canvas fills where a hex is required.
 */
export const BK = {
  paper: '#f3ecda',
  paperCard: '#efe6cf',
  ink: '#2b2519',
  inkSoft: '#5b513f',
  pine: '#2f4636',
  pineDeep: '#21342a',
  spruce: '#406149',
  walnut: '#7a4a32',
  walnutDeep: '#5b3724',
  barn: '#c2502f',
  barnDeep: '#8f3a20',
  gold: '#d9a441',
  lake: '#4a6d72',
} as const

export type BrandColor = keyof typeof BK
